import { z } from "zod"
import { booleanRequired, requiredMessage } from "@/models/common"
import { YES_NO_OPTIONS } from "@/modules/patients/detail/better-doc/de/lib/better-doc-consultation-questionnaire-definition"
import { getVisibleQuestions } from "@/modules/patients/detail/better-doc/de/lib/better-doc-consultation-questionnaire-visibility"
import type { BetterDocSpecialty } from "@/modules/patients/detail/better-doc/lib/better-doc-sub-specialties"
import {
  de_BetterDocBodyRegionValues,
  de_BetterDocChildAndAdolescentCheckUpValues,
  de_BetterDocConsultationReasonValues,
  de_BetterDocExcludingDiagnosisValues,
  de_BetterDocPreventiveCareScreeningValues,
  de_BetterDocPreviousDoctorValues,
  de_BetterDocSpecificExaminationValues,
  de_BetterDocSubSpecialityValues,
  de_BetterDocSymptomLocationValues,
} from "@/types/__generated__/union-types"

export const createDeBetterDocSearchSchema = (specialtyName: BetterDocSpecialty | undefined) =>
  z
    .object({
      transferDataConsent: booleanRequired,
      reasonForConsultations: z.enum(de_BetterDocConsultationReasonValues, { error: requiredMessage }),
      preventiveCareScreening: z.enum(de_BetterDocPreventiveCareScreeningValues).optional(),
      childAndAdolescentCheckUpDetails: z.enum(de_BetterDocChildAndAdolescentCheckUpValues).optional(),
      specificExamination: z.enum(de_BetterDocSpecificExaminationValues).optional(),
      bodyPartToExamine: z.string().trim().optional(),
      allergiesToTest: z.string().trim().optional(),
      bodyRegion: z.enum(de_BetterDocBodyRegionValues).optional(),
      subSpecialty: z.enum(de_BetterDocSubSpecialityValues).optional(),
      previousDoctor: z.enum(de_BetterDocPreviousDoctorValues).optional(),
      excludingDiagnosis: z.enum(de_BetterDocExcludingDiagnosisValues).optional(),
      symptomLocation: z.enum(de_BetterDocSymptomLocationValues).optional(),
      wasMagneticResonanceImagingDone: z.enum(YES_NO_OPTIONS).optional(),
      haveSymptomsLastedLongerThanOneMonth: z.enum(YES_NO_OPTIONS).optional(),
    })
    .superRefine((answers, context) => {
      for (const question of getVisibleQuestions(answers, specialtyName)) {
        if (question.isRequired && !answers[question.id]?.trim()) {
          context.addIssue({ code: "custom", path: [question.id], message: requiredMessage })
        }
      }
    })

export type DeBetterDocSearchFormType = z.infer<ReturnType<typeof createDeBetterDocSearchSchema>>
